<button
  class="absolute left-[-9999px] button button-primary button-xs focus:left-0 focus:z-[10000]"
  tabindex="0"
  aria-label="Skip to main content"
  (click)="focusFirstElement()"
>
  {{ buttonLabel }}
</button>
